/*export const BACKEND_URL = window.location.hostname === 'localhost' ? 'https://localhost:8443' :
    window.location.hostname === 'test.pinguino.com.ar' ? 'https://test.pinguino.com.ar:8443' :
        'https://pinguino.com.ar';
*/

import { Platform, Dimensions } from 'react-native';

let BACKEND_URL;

if (Platform.OS === 'web') {
  const hostname = typeof window !== 'undefined' ? window.location.hostname : '';

  BACKEND_URL =
    hostname === 'localhost'
      ? 'https://localhost:8443'
      : hostname === 'test.pinguino.com.ar'
        ? 'https://test.pinguino.com.ar:8443'
        : 'https://www.pinguino.com.ar';
} else {
  // URL para móvil (local o producción)
  BACKEND_URL = 'https://test.pinguino.com.ar:8443'; // O IP local si estás en desarrollo
}

// Función para obtener dimensiones responsivas para componentes
export const getViewportDimensions = () => {
  const { width } = Dimensions.get('window');
  // Altura responsiva basada en el ancho de la pantalla con diferentes breakpoints
  let height;
  if (width < 576) { // Móvil pequeño
    height = 180;
  } else if (width < 768) { // Móvil/Tablet
    height = 250;
  } else if (width < 992) { // Tablet/Desktop pequeño
    height = 320;
  } else if (width < 1200) { // Desktop mediano
    height = 380;
  } else { // Desktop grande
    height = 420;
  }
  return { width, height };
};

export const MONTO_MINIMO_ENVIO_GRATIS = 130000;

export const getEnvioGratisInfo = ({ total = 0, subtotal = null, montoMinimo = MONTO_MINIMO_ENVIO_GRATIS } = {}) => {
  const subtotalNumber = subtotal === null || subtotal === undefined ? NaN : parseFloat(subtotal);
  const totalNumber = parseFloat(total) || 0;
  const baseCalculo = Number.isFinite(subtotalNumber) ? subtotalNumber : totalNumber;
  const diferencia = montoMinimo - baseCalculo;
  const montoFaltante = diferencia > 0 ? diferencia : 0;
  const isGratis = montoFaltante <= 0;
  const progress = montoMinimo > 0 ? Math.min(Math.max(baseCalculo / montoMinimo, 0), 1) : 1;
  const montoFaltanteFormateado = montoFaltante.toLocaleString('es-AR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });

  return {
    montoMinimoEnvioGratis: montoMinimo,
    baseCalculo,
    diferencia,
    montoFaltante,
    montoFaltanteFormateado,
    isGratis,
    progress,
  };
};


// Función para detectar si estamos en producción
export const isProduccion = () => {
  if (typeof window === 'undefined') return false;
  return window.location.hostname === 'www.pinguino.com.ar';
};

// Función para obtener la URL del SDK de MODO según el entorno
export const getModoSDKUrl = () => {
  return isProduccion()
    ? 'https://ecommerce-modal.modo.com.ar/bundle.js' // Producción
    : 'https://ecommerce-modal.preprod.modo.com.ar/bundle.js'; // Test/Preprod
};

// Función para cargar el SDK de MODO en la página web (evita duplicados)
export const loadModoSDK = () => {
  if (typeof document === 'undefined') return;

  const scriptSrc = getModoSDKUrl();

  const existing = document.querySelector(
    'script[src*="ecommerce-modal.preprod.modo.com.ar/bundle.js"], script[src*="ecommerce-modal.modo.com.ar/bundle.js"]'
  );
  if (existing) return;

  const script = document.createElement('script');
  script.src = scriptSrc;
  script.async = true;
  document.body.appendChild(script);
};

export { BACKEND_URL };